export default "__VITE_ASSET__tsMeGItd__"